var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.2109H5C3.89543 11.2109 3 12.1064 3 13.2109V20.2109C3 21.3155 3.89543 22.2109 5 22.2109H19C20.1046 22.2109 21 21.3155 21 20.2109V13.2109C21 12.1064 20.1046 11.2109 19 11.2109Z",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11.2109V7.21094C7 5.88486 7.52678 4.61309 8.46447 3.6754C9.40215 2.73772 10.6739 2.21094 12 2.21094C13.3261 2.21094 14.5979 2.73772 15.5355 3.6754C16.4732 4.61309 17 5.88486 17 7.21094V11.2109",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fff965badfd787bdf1c73c2a9a347750.svg";
export { ForwardRef as ReactComponent };